import { Link } from 'react-router-dom';
import { t, getal } from '../i18n.js';
import { St } from './Status.jsx';

export const PLATFORM = { windows: 'Windows', macos: 'macOS', linux: 'Linux', ios: 'iOS', android: 'Android' };

/** Hoe zwaar een versie weegt: kritiek met een CVE op KEV, hoog bij CVSS 7 of meer (zoals het alert anyconnect-kwetsbaar). */
export const zwaar = (v) => v.cves.some((c) => c.kev || (c.score ?? 0) >= 7);

/**
 * De AnyConnect-versies met hun kwetsbaarheden uit NVD (docs/besluiten/anyconnect-versies.md), op VPN en bij een bron:
 * waar hij in gebruik is en op welke FMC hij staat, actief misbruikt (CISA KEV) in rood, met het open alert erbij.
 */
export default function AnyConnectVersies({ lijst, metKlant = false }) {
  return (
    <table>
      <thead><tr><th>{t('Versie')}</th><th>{t('Waar')}</th><th>{t('Kwetsbaarheden')}</th></tr></thead>
      <tbody>{lijst.map((v) => (
        <tr key={`${v.tenantId}-${v.platform}-${v.version}`}>
          <td><b className="mono">{v.version}</b><br /><span className="muted">{PLATFORM[v.platform] ?? v.platform}{metKlant && v.tenant ? ` · ${v.tenant}` : ''}</span></td>
          <td style={{ fontSize: 13 }}>
            {v.users > 0 && <div>{t('in gebruik bij {n} gebruiker(s), {l} logins', { n: getal(v.users), l: getal(v.logins) })}</div>}
            {v.fmc && <div className="muted">{t('op {fmc}', { fmc: v.fmc })}</div>}
            {v.alert && <div><Link to={`/alerts/${v.alert}`}>{v.alert}</Link></div>}
          </td>
          <td style={{ fontSize: 13 }}>
            {v.error && !v.cves.length ? <span className="muted">{t('NVD niet bereikt; volgende ronde opnieuw')}</span>
              : !v.checkedAt ? <span className="muted">{t('nog niet nagekeken')}</span>
              : !v.cves.length ? <St soort="good">{t('geen bekende kwetsbaarheden')}</St>
              : <div className="cvelijst">{v.cves.map((c) => (
                <a key={c.id} href={`https://nvd.nist.gov/vuln/detail/${c.id}`} target="_blank" rel="noreferrer" title={c.score ? `CVSS ${c.score}` : undefined}>
                  <St soort={c.kev ? 'critical' : (c.score ?? 0) >= 7 ? 'serious' : 'warning'}>{c.id}{c.kev ? ' · KEV' : ''}</St></a>))}</div>}
          </td>
        </tr>
      ))}</tbody>
    </table>
  );
}
